export * from './TagesplanSlider';
